import React from "react";

import pkg from "../../lib/pkg";
import { AnalyticsError } from "../../lib/util";
import { IntegrationCategory } from "../../providers/AnalyticsContext";
import useTrackEvent from "../useTrackEvent";
import { ActivityListing } from "./types";
import { mapActivityListingToProduct } from "./util";

const EVENT_NAME = "Product Clicked";

export default function useProductClicked() {
  const trackAdEvent = useTrackEvent(IntegrationCategory.Advertising);

  function track(activityListing: ActivityListing, index?: number) {
    try {
      // adding index check since DesktopCard defaults index to -1
      const product = mapActivityListingToProduct(
        activityListing,
        index ? (index > 0 ? index : 0) : undefined,
      );

      trackAdEvent(EVENT_NAME, product);
    } catch (error) {
      pkg.onError(new AnalyticsError(EVENT_NAME, error));
    }
  }

  return React.useCallback(track, [trackAdEvent]);
}
